import PropTypes from 'prop-types';
import React from 'react';
import {Typography} from '@material-ui/core';

const TlSubheader = ({children, style, ...rest}) => {
  const stl = Object.assign({}, style || {}, {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '48px',
  });
  return (
    <Typography
      {...rest}
      component={'span'}
      style={stl}
    >
      {children}
    </Typography>
  );
};

TlSubheader.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
};

export default TlSubheader;



// WEBPACK FOOTER //
// ./src/ondemand/components/TlSubheader.js